import { useContext } from 'react'
import { Context } from '../context/Context'

import './AccessLocationModal.css'
import { Button, Grid } from '@mui/material'
import { toast } from 'react-toastify'

const AccessLocationModal = ({ hideModal }) => {

    const context = useContext(Context)

    const getLocation = () => {
        navigator.geolocation.getCurrentPosition(position => {
            context.setlatitude(position.coords.latitude)
            context.setLongitude(position.coords.longitude)
            hideModal(false)
            localStorage.setItem('authorizedGeoLocation','1')
        },error => {
            switch(error.code){
                case error.PERMISSION_DENIED:
                    toast.error('مجوز دریافت موقعیت داده نشد')
                    break
                case error.POSITION_UNAVAILABLE:
                    toast.error('اطلاعات موقعیت در دسترس نبود')
                    break
                case error.TIMEOUT:
                    toast.error('زمان انتظار برای دریافت دسترسی به اتمام رسید')
                    break
                case error.UNKNOWN_ERROR:
                    toast.error('خطایی در دریافت موقعیت رخ داده است')
                    break
            }
            hideModal(false)
        })
    }

    return (
        <div id="access-location-modal">
            <div id="access-location-modal-content">
                <i className="fal fa-location-pin-lock"></i>
                <p>جهت مشاهده نزدیک ترین مراکز خدمت دهی، نیاز به موقعیت فعلی شما داریم.</p>
                <ul>
                    <li>1 - ابتدا بر روی دکمه دریافت موقعیت کلیک کنید</li>
                    <li>2 - حالا، بر روی دکمه Allow کلیک کنید</li>
                </ul>
                <Grid container spacing={1}>
                    <Grid item xs={7}>
                        <Button fullWidth variant="contained" color="secondary" onClick={getLocation} sx={{ py: 1.8 }}>دریافت موقعیت</Button>
                    </Grid>
                    <Grid item xs={5}>
                        <Button fullWidth variant="contained" color="inherit" onClick={() => hideModal(false)} sx={{ py: 1.8 }}>لغو</Button>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}

export default AccessLocationModal